import React from 'react';
import lessRequire from '../../../../config/less-require-resolver';
lessRequire('modules/offers/components/popups/IdPopup.less');

const IdPopup = ({intl, managerData}) => (
	<div className="id-frame__container">
		<div className="id-frame">
			<span className="image-tiger_1"/>
			<span className="id-frame__message">
				{intl('Для данного оффера доступен перевод ваших креативов на')}
				<strong> {intl('Индонезию')}</strong>
			</span>
		</div>
		<div className="id-frame__drop-down">
			<h4 className="drop-down__title font-proxima-nova-bold">{intl('Запускайте трафик на Индонезию')}</h4>
			<span className="drop-down__description">
				{intl('Запрашивайте перевод креативов у вашего персонального менеджера')}
			</span>
			<button
				className="button yellow-btn font-proxima-nova-semibold"
				onClick={e => {
					e.stopPropagation();
					e.preventDefault();
					window.open(`https://telegram.me/${managerData && managerData.telegram}`, '_blank');
				}}
			>
				{intl('Запросить перевод')}
			</button>
		</div>
	</div>
);

export default IdPopup;


// WEBPACK FOOTER //
// ./frontend/cabinets/modules/offers/components/popups/IdPopup.js